import type { FaireProductEntity } from "../../entity_types/product";

export const p_jkkhqc2dah: FaireProductEntity = {
  token: "p_jkkhqc2dah",
  type: "product",
  name: "The Plant Medicine Protocol",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/e713f21f25017f1e37b16795096953440c2417452b0593c7f38e9fd879739508.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.25,
  description:
    "A groundbreaking protocol for minimizing inflammation, boosting energy, building immunity, improving digestion, and so much more—with the extraordinary power of medicinal plants The power of medicinal plants is life-changing. When integrated properly into our lives, they are uniquely capable of fine-tuning and strengthening our vital systems. They help to enhance digestion, balance the nervous system, increase energy, improve sleep, promote resilience to stress, reduce inflammation, elevate mood and cognition, increase libido and fertility, boost immunity, support detoxification, nourish the microbiome, and rehydrate the system. And all you have to do?",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:42.311Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
